import { render } from "./admindasboard.vue?vue&type=template&id=c70a83e8"
import script from "./admindasboard.vue?vue&type=script&lang=js"
export * from "./admindasboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__